// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38025b76","455":"69e8ad56","977":"7e29bf17"}[chunkId] + ".chunk.js";
};